import { stateName } from './constants';

const localState = state => state[stateName];

export const getEmailCodeView = state => localState(state).emailCodeView;